module.exports = __webpack_public_path__ + "img/27.65ed7407.gif";